import React from "react";
import { AllJobs } from "../../components";

export default function AllJobsPage() {
  return (
    <React.Fragment>
      <h2 className={"content-block"}>All Jobs</h2>
      <AllJobs />
    </React.Fragment>
  );
}
